import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';
import { LoadingModule } from '@web/app/components/loading/loading.module';
import { PaymentsRefundDialogComponent } from './payments-refund-dialog.component';

@NgModule({
  declarations: [PaymentsRefundDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    WsUiModule,
    LoadingModule,
  ],
  exports: [PaymentsRefundDialogComponent],
})
export class PaymentsRefundDialogModule {}
